import { render } from "./Reader.vue?vue&type=template&id=4c05fe04&scoped=true"
import script from "./Reader.vue?vue&type=script&lang=js"
export * from "./Reader.vue?vue&type=script&lang=js"

import "./Reader.vue?vue&type=style&index=0&id=4c05fe04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c05fe04"]])

export default __exports__